import dayjs from 'dayjs'

export const NODE_STATUS = [{ value: 0, label: '未完成' }, { value: 1, label: '已完成' }]
export const MISSING_FILES = '请先上传节点文件，再将节点状态修改为已完成'
export type DateType = '总览' | '周' | '月' | '季' | '年'
// Copied from controlNodes/util.ts: local constants keep this domain request-free.
export const DATE_WIDTH = { 周: 158, 月: 58, 季: 100 / 7, 年: 158 / 30 }
export enum NodeShape { triangle = 0, paintDoubleCircle = 1, doubleCircle = 2, paintCircle = 3, circle = 4, moneyCanPay = 5, moneyBill = 6, moneyPartPaid = 7, moneyUnpaid = 8, moneyPaid = 9 }
export type ExternalLink = { toContractCode: string; toCode: string; label: string }
export interface RenderNode {
  id: number; nodeLabel: string; date: string | null; status: 0 | 1
  isDraw: boolean; isDds: boolean; isOutDate: boolean; overdueDays: number
  links: API.ControlNodesZb.LinkRef[]; nodeFiles: API.ControlNodesZb.FileItem[]
  milestone?: API.MilestoneZb.Item
  // 外部线（收款/费用/外协）节点才有：中文款项状态决定钱款形态
  moneyStatus?: string
  external?: {
    contractName?: string; supplierName?: string; purchasematter?: string
    paymentcondition?: string; paymentplancode?: string; pmCode?: string
    links?: ExternalLink[]
  }
}
export type RenderLineType = 'default' | 'zbMilestone' | 'payment' | 'expense' | 'special'
export interface RenderLine {
  lineID: number | string; lineName: string; colorValue: string
  nodeType: RenderLineType; nodes: RenderNode[]; assignName?: string
  // 外部线的原始合同编号（收款/费用线跳转应收应付页与关联弹窗定位用）
  externalCode?: string
  specialLink?: string
}
export const MONEY_COLOR = '#FCA210'
export const moneyShape = (status?: string): NodeShape => status === '已收款' || status === '已付款' ? NodeShape.moneyPaid : status === '部分收款' || status === '部分付款' ? NodeShape.moneyPartPaid : status === '已开票' ? NodeShape.moneyBill : status === '可收款' || status === '可付款' ? NodeShape.moneyCanPay : NodeShape.moneyUnpaid
export const moneyColor = (shape: NodeShape, fallback = ''): string => shape === NodeShape.moneyPaid ? '#00a854' : shape === NodeShape.moneyPartPaid ? '#a1a104' : shape === NodeShape.moneyBill ? '#FFAE42' : shape === NodeShape.moneyCanPay ? '#ff0000' : fallback
export const moneyColorByStatus = (status?: string) => moneyColor(moneyShape(status))
export const isMoneyShape = (shape: NodeShape) => shape >= NodeShape.moneyCanPay
export const dateOnly = (value?: string | null): string | null => {
  if (!value) return null
  const date = value.slice(0, 10)
  return validDate(date) ? date : null
}
export const validDate = (value?: string | null): value is string => !!value && /^\d{4}-\d{2}-\d{2}$/.test(value) && dayjs(value).isValid() && dayjs(value).format('YYYY-MM-DD') === value
export const overdueDays = (date: string | null, status: number, today = dayjs().format('YYYY-MM-DD')) => status === 0 && validDate(date) ? Math.max(0, dayjs(today).startOf('day').diff(dayjs(date).startOf('day'), 'day')) : 0
export const nodeShape = (n: RenderNode): NodeShape => n.moneyStatus !== undefined ? moneyShape(n.moneyStatus) : n.isOutDate ? NodeShape.triangle : n.isDraw ? (n.status === 1 ? NodeShape.paintDoubleCircle : NodeShape.doubleCircle) : n.status === 1 ? NodeShape.paintCircle : NodeShape.circle
export const groupNodes = (nodes: RenderNode[]) => {
  const groups = new Map<string, RenderNode[]>()
  nodes.forEach(n => {
    if (!validDate(n.date)) return
    const group = groups.get(n.date)
    if (group) group.push(n)
    else groups.set(n.date, [n])
  })
  return Array.from(groups, ([date, children]) => ({ date, children, shape: Math.min(...children.map(nodeShape)) }))
}
export const calendarRange = (lines: RenderLine[], today = dayjs().format('YYYY-MM-DD')): [string, string] => {
  const dates = lines.flatMap(l => l.nodes.map(n => n.date).filter(validDate)).sort()
  if (!dates.length) return [today, dayjs(today).add(1, 'year').format('YYYY-MM-DD')]
  return [dates[0], dates[dates.length - 1]]
}
export const position = (date: string, start: string, end: string) => dayjs(date).diff(dayjs(start), 'day') / Math.max(1, dayjs(end).diff(dayjs(start), 'day')) * 100
export const validateLine = (value: Request.ControlNodesZb.Line) => {
  if (!value.nodes.length) return '请至少添加一个节点~'
  if (!value.lineName.trim()) return '任务线名称不可为空~'
  if (value.nodes.some(n => !n.nodeName.trim())) return '节点名称不可为空~'
  return ''
}
export const syncChecked = (previousIDs: (number | string)[], checked: (number | string)[], nextIDs: (number | string)[]) => nextIDs.filter(id => !previousIDs.includes(id) || checked.includes(id))
